import { render, staticRenderFns } from "./aiCopywriter.vue?vue&type=template&id=595cc060&scoped=true&"
import script from "./aiCopywriter.vue?vue&type=script&lang=js&"
export * from "./aiCopywriter.vue?vue&type=script&lang=js&"
import style0 from "./aiCopywriter.vue?vue&type=style&index=0&id=595cc060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595cc060",
  null
  
)

export default component.exports